import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';

Vue.use(Vuex);

Vue.config.devtools = process.env.NODE_ENV === 'development';

function createStore() {
  // https://webpack.js.org/guides/dependency-management/#requirecontext
  const modulesFiles = require.context('./modules', true, /\.js$/);

  // you do not need `import app from './modules/app'`
  // it will auto require all vuex module from modules file
  // eslint-disable-next-line no-shadow
  const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    // set './app.js' => 'app'
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
    const value = modulesFiles(modulePath);
    // eslint-disable-next-line no-param-reassign
    modules[moduleName] = value.default;
    return modules;
  }, {});

  return new Vuex.Store({
    modules,
    getters,
  });
}

const store = createStore();

export default store;
